/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_Faq_Q2Inputs */

const en_guide_json_rest_api_faq_q2 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Should I always use application/json content type?`)
};

const ko_guide_json_rest_api_faq_q2 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`항상 application/json content type을 사용해야 하나요?`)
};

const ja_guide_json_rest_api_faq_q2 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常にapplication/jsonコンテンツタイプを使用すべきですか？`)
};

/**
* | output |
* | --- |
* | "Should I always use application/json content type?" |
*
* @param {Guide_Json_Rest_Api_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_faq_q2 = /** @type {((inputs?: Guide_Json_Rest_Api_Faq_Q2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_Faq_Q2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_faq_q2(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_faq_q2(inputs)
	return ja_guide_json_rest_api_faq_q2(inputs)
});